import React from 'react';
import {
  FilterBar,
  FilterSelect
} from './FilterBar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

/**
 * Exports Filter Bar Component
 * Uses shared FilterBar components for consistency (mirrors ShipmentFilterBar pattern)
 */
export default function ExportsFilterBar({
  // Search
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search booking, container, customer...',
  // Filters
  showFilters,
  onToggleFilters,
  statusFilter,
  onStatusFilterChange,
  sslFilter,
  onSslFilterChange,
  driverFilter,
  onDriverFilterChange,
  customerFilter,
  onCustomerFilterChange,
  // Data for filters
  statusOptions = [],
  sslOptions = [],
  driverOptions = [],
  customerOptions = [],
  // Include closed / hidden statuses
  includeClosed,
  onIncludeClosedChange,
  hiddenStatuses,
  onHiddenStatusesChange,
  // Sort
  sortColumn,
  sortDirection,
  onClearSort,
  // Column settings
  columnsChanged,
  savingColumns,
  onSaveColumns,
  onOpenColumnSettings,
  // Actions
  onRefresh,
  onClearFilters,
  hasActiveFilters,
  // Bulk
  selectedCount,
  onOpenBulkStatus
}) {
  // Render additional filters for expandable section
  const additionalFilters = (
    <>
      {/* Status Filter */}
      <FilterSelect
        value={statusFilter}
        onChange={onStatusFilterChange}
        options={statusOptions.map(s => ({ id: s, name: s }))}
        placeholder="Filter by Status"
        allLabel="All Statuses"
        className="w-full sm:w-[180px]"
        testId="status-filter"
      />

      {/* SSL Filter */}
      <FilterSelect
        value={sslFilter}
        onChange={onSslFilterChange}
        options={sslOptions}
        placeholder="Filter by SSL"
        allLabel="All SSLs"
        className="w-full sm:w-[150px]"
        testId="ssl-filter"
      />

      {/* Driver Filter */}
      <FilterSelect
        value={driverFilter}
        onChange={onDriverFilterChange}
        options={driverOptions}
        placeholder="Filter by Driver"
        allLabel="All Drivers"
        className="w-full sm:w-[150px]"
        testId="driver-filter"
      />

      {/* Customer Filter */}
      <FilterSelect
        value={customerFilter}
        onChange={onCustomerFilterChange}
        options={customerOptions}
        placeholder="Filter by Customer"
        allLabel="All Customers"
        className="w-full sm:w-[150px]"
        testId="customer-filter"
      />
    </>
  );

  return (
    <FilterBar
      // Search
      searchValue={searchTerm}
      onSearchChange={onSearchChange}
      searchPlaceholder={searchPlaceholder}
      searchTestId="export-search-input"
      // Expandable filters
      additionalFilters={additionalFilters}
      showFilters={showFilters}
      onToggleFilters={onToggleFilters}
      hasActiveFilters={hasActiveFilters}
      onClearFilters={onClearFilters}
      // Refresh
      showRefresh={true}
      onRefresh={onRefresh}
      // Include closed
      showIncludeClosed={true}
      includeClosed={includeClosed}
      onIncludeClosedChange={onIncludeClosedChange}
      // Hidden statuses
      hiddenStatuses={hiddenStatuses}
      onHiddenStatusesChange={onHiddenStatusesChange}
      // Sort
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      onClearSort={onClearSort}
      // Column settings
      showColumnSettings={true}
      onOpenColumnSettings={onOpenColumnSettings}
      columnsChanged={columnsChanged}
      savingColumns={savingColumns}
      onSaveColumns={onSaveColumns}
      // Custom actions - bulk status
      customActions={
        selectedCount > 0 ? (
          <Button
            size="sm"
            onClick={onOpenBulkStatus}
            className="bg-blue-600 hover:bg-blue-500"
          >
            Bulk Update ({selectedCount})
          </Button>
        ) : null
      }
    />
  );
}
